/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function LinkBreak(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M87.99951,72V48a8,8,0,1,1,16,0V72a8,8,0,0,1-16,0Zm72,104a8.00039,8.00039,0,0,0-8,8v24a8,8,0,0,0,16,0V184A8.00039,8.00039,0,0,0,159.99951,176Zm-112-72h24a8,8,0,0,0,0-16h-24a8,8,0,1,0,0,16Zm160,48h-24a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Zm-86.05859,27.31348L110.62744,190.627a32,32,0,0,1-45.25586-45.2539L76.686,134.05957a7.99983,7.99983,0,0,0-11.3125-11.31445L54.05811,134.05957a48.00041,48.00041,0,0,0,67.88378,67.88184l11.31348-11.31348a8.00052,8.00052,0,0,0-11.31445-11.31445ZM190.62744,65.37207a32.03762,32.03762,0,0,1,.001,45.25488L179.314,121.94043a7.99983,7.99983,0,1,0,11.3125,11.31445l11.31543-11.31445a48.0004,48.0004,0,1,0-67.88378-67.88184L122.74463,65.37207a8.00052,8.00052,0,0,0,11.31445,11.31445l11.31348-11.31347A32.035,32.035,0,0,1,190.62744,65.37207Z" />
    </Svg>
  );
}

export default LinkBreak;
